
import { defineComponent, computed } from '@vue/composition-api';

type NotificationPosition =
  | 'top-right'
  | 'top-left'
  | 'bottom-right'
  | 'bottom-left';

export default defineComponent({
  name: 'NotificationContainer',
  props: {
    position: {
      type: String as () => NotificationPosition,
      default: 'top-right'
    }
  },
  setup(props) {
    const containerClasses = computed(() => {
      const classes: Record<NotificationPosition, string> = {
        'top-right': 'justify-end px-4 sm:px-6',
        'top-left': 'justify-start px-4 sm:px-6',
        'bottom-right': 'justify-end px-4 sm:px-6',
        'bottom-left': 'justify-start px-4 sm:px-6'
      };
      return classes[props.position];
    });

    const innerClasses = computed(() => {
      const classes: Record<NotificationPosition, string> = {
        'top-right': 'items-end',
        'top-left': 'items-start',
        'bottom-right': 'items-end',
        'bottom-left': 'items-start'
      };
      return classes[props.position];
    });

    return {
      containerClasses,
      innerClasses
    };
  }
});
